import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';

export const CharacteristicEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="unit" label="Единица измерения" placeholder="кг, л.с., м³" />
      <TextInput source="description" multiline rows={3} fullWidth />
      
      <ReferenceInput source="groupId" reference="characteristic-groups">
        <SelectInput optionText="name" validate={[required()]} />
      </ReferenceInput>
      
      <NumberInput source="sortOrder" />
      <BooleanInput source="isActive" />
    </SimpleForm>
  </Edit>
);
